module.exports = __webpack_public_path__ + "static/media/Metropolis-Regular.2bc8c5ba.svg";